module.exports = __webpack_public_path__ + "img/greyedwardjames.2f51a271.webp";